import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showLoader, hideLoader } from '../../../store/common/slice';
import { constants } from '../../../common/constants/constants';
import Datepicker from '../../../common/DatepickerPortal';
import Button from '../../../common/Button';
import transferCoins from '../../../images/newDesign/transfer_coins.svg';
import bllinkLogo from '../../../images/newDesign/bllink_logo.svg';
import check from '../../../images/newDesign/check.svg';

const AddPaymentMethodReccurring = ({ 
        monthsNum, 
        amount, 
        currency, 
        vendorName, 
        choosePaymentMethod, 
        setChoosePaymentMethod, 
        vendor, 
        buildingID, 
        setShowConfirmation,
        date,
        setConfirmationDate,
        setShowAddExpense,
        setShowAddPaymentMethod,
        setAddPaymentMethodPayload 
    }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const ltr = useSelector(state => state.common.ltrEnabled);

    document.querySelector('.fade').scrollTo(0,0);

    const [currentDate, setCurrentDate] = useState(date);
    const [btnDisabled, setBtnDisabled] = useState(true);

    const currencySign = t(`currency.${currency}`);

    const onDatePickerChange = date => {
        setCurrentDate(date);
        setConfirmationDate(date);
    };

    useEffect(() => {
        if (currentDate) setBtnDisabled(false)
        else setBtnDisabled(true)
    }, [currentDate]);

    const onContinueClick = () => setChoosePaymentMethod(false);

    const onApproveClick = async () => {
        dispatch(showLoader());

        const payload = {
            buildingID,
            paymentDate: {
                month: currentDate.getMonth()+1,
                year: currentDate.getFullYear(),
                day: currentDate.getDate()
            },
            paymentMethod: constants.managerPaymentsOptions.bankCharge,
            vendorID: vendor.value
        };

        setAddPaymentMethodPayload(payload);
        setShowConfirmation(true);

        dispatch(hideLoader());
    };

    const onStepBackClick = () => {
        setShowAddPaymentMethod(false);
        setShowAddExpense(true);
        setChoosePaymentMethod(true);
    };

    return (
        <div className='set-reccurent-payment'>
            <div className='progress-line'>
                <div className='step' onClick={onStepBackClick}>
                    <div className='progress-step current'><img src={check} /></div>
                    <div className='current-text'>{t('expenses.set_expenses.first_step')}</div>
                </div>

                <div className='divider-line first'></div>
                <div className='divider-line-done-first'></div>

                <div className='step'>
                    <div className='progress-step'>2</div>
                    <div>{t('expenses.set_expenses.second_step')}</div>
                </div>

                <div className='divider-line second'></div>

                <div className='step'>
                    <div className='progress-step'>3</div>
                    <div>{t('expenses.set_expenses.third_step')}</div>
                </div>
            </div>
            <div className='set-payment-info'>{t('expenses.set_expenses.set_reccurent_payment', {
                returnObjects: true,
                monthsNum: (<span class='add-payment-highlithed'>{monthsNum}</span>), 
                amount: (<span class='add-payment-highlithed'>{`${amount}${currencySign}`}</span>), 
                vendorName: (<span class='add-payment-highlithed'>{vendorName}</span>)
            })}</div>

            {choosePaymentMethod && (
                <>
                    <div className='payment-method bllink-method selected'>
                        <img src={bllinkLogo} />
                        <div>
                            <div>{t('expenses.set_expenses.pay_with_bllink')}</div>
                            <div className='notice'>{t('expenses.set_expenses.easy_payment')}</div>
                        </div>
                    </div>

                    <img src={transferCoins} className='transfer-coins-img' />

                    <Button
                        type='button'
                        onClick={onContinueClick}
                        rounded={false}
                    >                 
                        {t('expenses.set_expenses.continue')}
                    </Button>                 
                </>
            )}

            {!choosePaymentMethod && (
                <>
                    <div className='payment-method-info'>
                        <img src={bllinkLogo} />
                        <div>
                            <div>{t('expenses.set_expenses.pay_with_bllink')}</div>
                            <div className='notice'>{t('expenses.set_expenses.free')}</div>
                        </div>
                    </div>

                    <div className='datepicker-wrapper select-payment'>
                        <label>{t('offline_payments.payment_date')}</label>
                        <Datepicker 
                            date={currentDate}
                            onChange={onDatePickerChange}          
                            className='one-line-design'
                            placeholder={t('expenses.set_expenses.select_date')}
                            ltr={ltr}
                            withPortal={false}
                            showArrow={false}
                            container
                        />
                    </div>

                    <img src={transferCoins} className='transfer-coins-img' />
                    
                    <Button
                        type='button'
                        onClick={onApproveClick}
                        rounded={false}
                        disabled={btnDisabled}
                    >                 
                        {t('expenses.approve')}
                    </Button>
                </>
            )}
        </div>
    )
}

export default AddPaymentMethodReccurring;